import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { t } from '../../utils/resources';
import './MaxLengthInfo.less';

export interface MaxLengthInfoProps {
  className?: string;
  children?: React.ReactElement;
  postfix?: string;
  prefix?: string;
  value?: string | string[];
  maxLength?: number;
}

export const MaxLengthInfo = (props: MaxLengthInfoProps) => {
  const { className, children, postfix, prefix, value } = props;

  const [length, setLength] = useState(value ? value.length : 0);
  const maxLength = props.maxLength ?? children?.props.maxLength;

  useEffect(() => {
    setLength(value ? value.length : 0);
  }, [value]);

  return (
    <>
      {maxLength && (
        <div className={clsx('max-length-info-wrapper', className ?? '')}>
          {children}
          <p className={clsx('max-length-info', length > 0 ? 'active' : '')}>
            {prefix} {length}/{maxLength} {postfix}
            {!prefix && !postfix && t('MaxLengthInfo.postfix')}
          </p>
        </div>
      )}
      {!maxLength && children}
    </>
  );
};
